import {Box, Button, Dialog, DialogActions, DialogContent, DialogTitle} from '@mui/material';
import {useTranslation} from 'react-i18next';

export interface ExitConfirmationModalProps {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  confirmColor?: 'error' | 'success' | 'warning' | 'info' | 'primary';
}

export default function ExitConfirmationModal({
  open,
  onConfirm,
  onCancel,
  confirmColor = 'error'
}: ExitConfirmationModalProps) {
  const {t} = useTranslation(['shared/common']);

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      aria-labelledby="confirmation-dialog-title"
      aria-describedby="confirmation-dialog-description"
    >
      <DialogTitle id="confirmation-dialog-title">
        {t('shared/common:diagnosticReport.form.exitConfirmationModal.title')}
      </DialogTitle>
      <DialogContent sx={{marginTop: 1}}>
        <Box id="confirmation-dialog-description">
          {t('shared/common:diagnosticReport.form.exitConfirmationModal.text')}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color="primary" autoFocus>
          {t('shared/common:diagnosticReport.form.exitConfirmationModal.stay')}
        </Button>
        <Button onClick={onConfirm} color={confirmColor} variant="contained">
          {t('shared/common:diagnosticReport.form.exitConfirmationModal.exit')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
